import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatbotSection, ChatbotSectionListData, ChatbotSectionsState } from '../../types/chatbotSections.types';

const initialState: ChatbotSectionsState = {
  sections: [],
  selectedSection: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
  sort: {
    field: 'createdAt',
    order: 'desc',
  },
};

const chatbotSectionsSlice = createSlice({
  name: 'chatbotSections',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setSections(state, action: PayloadAction<ChatbotSectionListData>) {
      state.sections = action.payload.sections;
      state.pagination.totalPages = action.payload.totalPages;
      state.pagination.totalRecords = action.payload.totalRecords;
      state.pagination.hasMorePages = action.payload.hasMorePages;
    },
    setSelectedSection(state, action: PayloadAction<ChatbotSection | null>) {
      state.selectedSection = action.payload;
    },
    clearSelectedSection(state) {
      state.selectedSection = null;
    },
    setPage(state, action: PayloadAction<number>) {
      state.pagination.page = action.payload;
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pagination.pageSize = action.payload;
      state.pagination.page = 1;
    },
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    setSort(state, action: PayloadAction<{ field: string; order: string }>) {
      state.sort = action.payload;
      state.pagination.page = 1;
    },
    addSection(state, action: PayloadAction<ChatbotSection>) {
      state.sections.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateSection(state, action: PayloadAction<ChatbotSection>) {
      const index = state.sections.findIndex((s) => s.id === action.payload.id);
      if (index !== -1) {
        state.sections[index] = action.payload;
      }
    },
    removeSection(state, action: PayloadAction<string>) {
      state.sections = state.sections.filter((s) => s.id !== action.payload);
      state.pagination.totalRecords -= 1;
    },
  },
});

export const {
  setLoading,
  setError,
  setSections,
  setSelectedSection,
  clearSelectedSection,
  setPage,
  setPageSize,
  setSearch,
  setSort,
  addSection,
  updateSection,
  removeSection,
} = chatbotSectionsSlice.actions;

export default chatbotSectionsSlice.reducer;
